<template>
  <el-breadcrumb separator="»">
    <el-breadcrumb-item :to="{ path: '/app/initiatives' }">
      <span class="gray-color">Dashboard</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item>
      <span class="dark-color">{{ item }}</span>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>

export default {
  name: "BreadCrumb",
  props: {
    item: {
      type: String
    }
  }
}
</script>

<style scoped lang="css">
.gray-color {
  font-size: 14px;
  color: #7B839E;
}
.dark-color {
  font-size: 14px;
  color: #000;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>